import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ZeitSlot, ZeitSlotTag } from '../zeitslot';
import { HttpParams } from '@angular/common/http';
import { DateUtils } from '../../../../../../../../../src/app/dialogs/calendar-week-picker/date-utils';
import { KieneBackendApiService } from '../../../../../services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../../kiene-core.config';

@Component({
    selector: 'kiene-zeitslot-buchen-bottom-sheet',
    templateUrl: './zeitslot-buchen-bottom-sheet.component.html',
    styleUrls: ['./zeitslot-buchen-bottom-sheet.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ZeitslotBuchenBottomSheetComponent implements OnInit {
    currentDate: Date = new Date();
    selectedDate: Date = new Date();

    day: ZeitSlot[] = [];
    days: ZeitSlotTag[] = [];

    constructor(
        public bottomSheetRef: MatBottomSheetRef<ZeitslotBuchenBottomSheetComponent>,
        private api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: { schlachthof_id: number },
    ) {}

    ngOnInit() {
        this.ladeVerfuegbareZeitslots(new Date());
    }

    ladeVerfuegbareZeitslots(day: Date) {
        this.selectedDate = day;
        let params = new HttpParams().append('betrieb_id', this.data.schlachthof_id);
        let fromDate = DateUtils.getStartOfMonth(day);
        let toDate = DateUtils.getEndOfMonth(day);
        params = params.append('zeit_von', fromDate.toISOString());
        params = params.append('zeit_bis', toDate.toISOString());

        this.api.get(this.apiBaseUrl + '/zeitslot/read.php', params).subscribe(res => {
            let zeitslots = res.records as ZeitSlot[];
            let days = [];
            for (let i = 0; i < 31; i++) {
                let day = new ZeitSlotTag();
                day.day = DateUtils.plusDays(fromDate, i);
                day.slots = zeitslots.filter(zeitslot =>
                    DateUtils.isSameDay(new Date(zeitslot.datum_uhrzeit_von), day.day),
                );
                days.push(day);
            }
            this.days = days;
            this.renderCalendar(undefined);
            this.daySelected(day);
        });
    }

    daySelected(day: Date) {
        this.day = this.days.find(tag => DateUtils.isSameDay(day, tag.day))?.slots;
    }

    renderCalendar(event) {
        setTimeout(() => {
            const cells = Array.from(
                document.querySelectorAll<HTMLDivElement>('.mat-calendar .mat-calendar-body-cell-content'),
            );

            for (let i = 0; i < cells.length; i++) {
                if (this.days[i].slots.length === 0 || this.days[i + 1].day < this.currentDate) {
                    cells[i].innerHTML =
                        '<span style="text-decoration: line-through; color: lightgrey">' +
                        cells[i].innerText +
                        '</span>';
                } else {
                    cells[i].innerHTML = '<span class="dot-green"></span><span>' + cells[i].innerText + '</span>';
                }
            }
        });
    }
}
